import { useState, useRef } from "react";
import { motion } from "framer-motion";

import axiosClient from "../../../config/clientAxios";

import { AppWrap } from "./../../HOC/AppWrap";
import { MotionWrap } from "./../../HOC/MotionWrap";

import images from "../../../constants/images";

import "./Footer.scss";

const Footer = () => {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formsubmitted, setFormSubmitted] = useState(false);

  const form = useRef();

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading((c) => !c);

    const formData = new FormData(form.current);

    if (
      formData.get("name").trim() === "" ||
      formData.get("email").trim() === "" ||
      formData.get("message").trim() === ""
    ) {
      setError("Todos los campos son requeridos");
      setLoading(false);

      return;
    }

    if (
      /(<[a-z>(')/<]*)/.exec(formData.get("name")) ||
      /(<[a-z>(')/<]*)/.exec(formData.get("email")) ||
      /(<[a-z>(')/<]*)/.exec(formData.get("message"))
    ) {
      setError("No se aceptan caracteres especiales");
      setLoading(false);

      return;
    }

    const user = {
      name: formData.get("name"),
      email: formData.get("email"),
      message: formData.get("message"),
    };

    try {
      const {
        data: { message },
      } = await axiosClient.post("/contactme", user);

      console.log("message", message);

      setLoading((c) => !c);
      setFormSubmitted((c) => !c);
    } catch (error) {
      setLoading((c) => !c);
      console.log("error", error);
    }
  };

  return (
    <>
      <h2 className="head-text">
        <span>Tómate un café</span> y chatea conmigo
      </h2>

      <motion.div className="app__footer-cards">
        <div className="app__footer-card">
          <img src={images.email} alt="email" />
          <a href="mailto:emanuelmamani310@gmail.com" className="p-text">
            emanuelmamani310@gmail.com
          </a>
        </div>
        <div className="app__footer-card">
          <img src={images.mobile} alt="mobile" />
          <a href="tel: +54 (388) 5232912" className="p-text">
            +54 (388) 5232912
          </a>
        </div>
      </motion.div>

      {!formsubmitted ? (
        <motion.div className="app__footer-form app__flex">
          <form ref={form}>
            <div className="app__flex">
              <input
                type="text"
                name="name"
                className="p-text"
                disabled={loading}
                placeholder="Nombre completo"
              />
            </div>
            <div className="app__flex">
              <input
                type="email"
                name="email"
                className="p-text"
                disabled={loading}
                placeholder="Email"
              />
            </div>

            <div>
              <textarea
                name="message"
                className="p-text"
                placeholder="Mensaje"
              />
            </div>
            <button
              type="submit"
              className="p-text"
              disabled={loading}
              onClick={handleSubmit}
            >
              {loading ? "Sending..." : "Send Message"}
            </button>
          </form>
        </motion.div>
      ) : (
        <motion.div>
          <h3 className="head-text">
            Gracias por contactarte con migo, en unos minutos te respondere!! :D
          </h3>
        </motion.div>
      )}
    </>
  );
};

export default AppWrap(MotionWrap(Footer, "app__footer"), "contact");
